import Image from 'next/image';
import { Typography } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';

import { ETolgeeHome, ETolgeeNamespaces } from '~/shared/enums';

import bannerImg from '~/../public/img/banner-nossas-marcas-2520px.png';
import logoAmbev from '~/../public/img/logo-ambev.png';

export function EmptyHome() {
  const { t } = useTranslate(ETolgeeNamespaces.HOME);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-4 pt-4">
        <Typography
          variant="display-sm-bold"
          className="text-[var(--theme-color-text-dark)] whitespace-pre-line leading-[38px]"
          style={{ fontFamily: 'AmbevCurva' }}
          as="p">
          {t(ETolgeeHome.EMPTY_HOME_TITLE)}
        </Typography>

        <Image
          src={bannerImg}
          alt="Banner Nossas Marcas"
          className="w-full h-auto"
        />

        <div className="flex items-center justify-center">
          <Image
            src={logoAmbev}
            alt="Logo Ambev"
            className="max-w-full h-auto"
          />
        </div>
      </div>
    </div>
  );
}
